import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Generator from "@/pages/Generator";
import Impressum from "@/pages/legal/Impressum";
import Datenschutz from "@/pages/legal/Datenschutz";
import AGB from "@/pages/legal/AGB";
import Kontakt from "@/pages/Kontakt";
import TrauerredeMann from "@/pages/persona/TrauerredeMann";
import TrauerredeFrau from "@/pages/persona/TrauerredeFrau";
import TrauerredeEhepartner from "@/pages/persona/TrauerredeEhepartner";
import TrauerredeMutter from "@/pages/persona/TrauerredeMutter";
import TrauerredeVater from "@/pages/persona/TrauerredeVater";
import TrauerredeBruder from "@/pages/persona/TrauerredeBruder";
import TrauerredeSchwester from "@/pages/persona/TrauerredeSchwester";
import TrauerredeFreund from "@/pages/persona/TrauerredeFreund";
import TrauerredeKollege from "@/pages/persona/TrauerredeKollege";
import TrauerredeOma from "@/pages/persona/TrauerredeOma";
import TrauerredeOpa from "@/pages/persona/TrauerredeOpa";
import TrauerredeMama from "@/pages/persona/TrauerredeMama";
import TrauerredePapa from "@/pages/persona/TrauerredePapa";
import TrauerredeTochter from "@/pages/persona/TrauerredeTochter";
import TrauerredeSohn from "@/pages/persona/TrauerredeSohn";
import TrauerredeSchreiben from "@/pages/guide/TrauerredeSchreiben";
import WieLangTrauerrede from "@/pages/guide/WieLangTrauerrede";
import TrauerredeEinleitung from "@/pages/guide/TrauerredeEinleitung";
import TrauerredeHalten from "@/pages/guide/TrauerredeHalten";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/generator" element={<Generator />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/trauerrede-mann" element={<TrauerredeMann />} />
          <Route path="/trauerrede-frau" element={<TrauerredeFrau />} />
          <Route path="/trauerrede-ehepartner" element={<TrauerredeEhepartner />} />
          <Route path="/trauerrede-mutter" element={<TrauerredeMutter />} />
          <Route path="/trauerrede-vater" element={<TrauerredeVater />} />
          <Route path="/trauerrede-bruder" element={<TrauerredeBruder />} />
          <Route path="/trauerrede-schwester" element={<TrauerredeSchwester />} />
          <Route path="/trauerrede-freund" element={<TrauerredeFreund />} />
          <Route path="/trauerrede-kollege" element={<TrauerredeKollege />} />
          <Route path="/trauerrede-oma" element={<TrauerredeOma />} />
          <Route path="/trauerrede-opa" element={<TrauerredeOpa />} />
          <Route path="/trauerrede-mama" element={<TrauerredeMama />} />
          <Route path="/trauerrede-papa" element={<TrauerredePapa />} />
          <Route path="/trauerrede-tochter" element={<TrauerredeTochter />} />
          <Route path="/trauerrede-sohn" element={<TrauerredeSohn />} />
          <Route path="/trauerrede-schreiben" element={<TrauerredeSchreiben />} />
          <Route path="/wie-lang-trauerrede" element={<WieLangTrauerrede />} />
          <Route path="/trauerrede-einleitung" element={<TrauerredeEinleitung />} />
          <Route path="/trauerrede-halten" element={<TrauerredeHalten />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
